import { gql } from "@apollo/client";

export const groupConnectionsFragment = gql`
    fragment GroupConnections on GroupWithConnections {
        group {
            id
            totalNumLenses
        }
        connections {
            connectionId
            lens {
                compoundId {
                    id
                    reference
                    lensSourceType
                }
            }
        }
    }
`;
